"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxBadge = exports.validBoxBadgeColors = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
exports.validBoxBadgeColors = [
    'red50',
    'orange50',
    'yellow50',
    'green50',
    'green30',
    'neutral40',
    'neutral60',
    'neutral90',
];
// using inline instead of inline-flex to support "text-overflow: ellipsis" from parent
var boxBadgeStyle = function (color) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline;\n  position: relative;\n  padding-left: 24px;\n  white-space: nowrap;\n\n  &::before {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 0;\n    min-width: 16px;\n    height: 16px;\n    content: \"\";\n    background-color: ", ";\n  }\n"], ["\n  display: inline;\n  position: relative;\n  padding-left: 24px;\n  white-space: nowrap;\n\n  &::before {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 0;\n    min-width: 16px;\n    height: 16px;\n    content: \"\";\n    background-color: ", ";\n  }\n"])), design_system_foundations_1.theme.color[color]); };
exports.BoxBadge = (0, react_1.forwardRef)(function (_a, ref) {
    var color = _a.color, children = _a.children, testId = _a.testId, className = _a.className, style = _a.style, rest = __rest(_a, ["color", "children", "testId", "className", "style"]);
    if (!exports.validBoxBadgeColors.includes(color)) {
        throw new Error("Invalid badge color, valid colors are [".concat(exports.validBoxBadgeColors, "] and you passed in [").concat(color, "]."));
    }
    var boxBadgeClasses = (0, react_1.useMemo)(function () { return (0, css_1.cx)(boxBadgeStyle(color), className, 'ds-box-badge'); }, [className, color]);
    return (react_1.default.createElement("span", __assign({ className: boxBadgeClasses, style: style, ref: ref, "data-testid": testId }, rest), children));
});
exports.BoxBadge.displayName = 'BoxBadge';
var templateObject_1;
